import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, ViewChild } from '@angular/core';
import { MdbModalRef, MdbModalService } from 'mdb-angular-ui-kit/modal';
import { MdbTableDirective } from 'mdb-angular-ui-kit/table';
import { GenericCrudService } from 'src/app/services/crud/generic-crud.service';
import { Company, TipoDocumento, Tag } from 'src/app/models/interfaces.model';
import { MdbFileUploadComponent } from 'mdb-angular-file-upload';
import { environment } from 'src/app/environments/environments';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ModalDocumentosSgiComponent } from 'src/app/components/crud/modal-documentos-sgi/modal-documentos-sgi.component';
import { ModalDocumentosDetailsComponent } from 'src/app/components/crud/modal-documentos-detail/modal-documentos-detail.component';
import { PdfWatermarkService } from 'src/app/pdf-watermark.service';
import { DataDocumentService } from 'src/app/services/data-document.service';
import { Router } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MdbChipAddEvent } from 'mdb-angular-ui-kit/chips';
import { take, forkJoin } from 'rxjs';

@Component({
  selector: 'app-documents',
  templateUrl: './documents.component.html',
  styleUrls: ['./documents.component.css'],
})
export class DocumentsComponent {
  constructor(
    private modalService: MdbModalService,
    private httpClient: HttpClient,
    private formBuilder: FormBuilder,
    private router: Router,
    public dataDocumentService: DataDocumentService,
    private sanitizer: DomSanitizer,
    private crudService: GenericCrudService<Company>
  ) {
    this.form = this.formBuilder.group({
      TipoDocumento: ['', Validators.required],
      DetalleTipoDocumento: ['', Validators.required],
    });

    this.formGroup = this.formBuilder.group({
      // ... Otros controles
      DetalleTipoDocumento: new FormControl(null), // O el valor inicial que desees
      TipoDocumento: false,
    });
  }

  @ViewChild('table') table!: MdbTableDirective<Company>;
  @ViewChild('fileUpload') fileUpload!: MdbFileUploadComponent;

  searchResults: any[] = [];
  modalRefDocuments: MdbModalRef<ModalDocumentosSgiComponent> | null = null;
  modalRefDocumentsDetail: MdbModalRef<ModalDocumentosDetailsComponent> | null = null;
  editElementIndex = -1;
  addRow = false;
  sort = false;
  dataSource: any[] = [];
  tags: Tag[] = [];
  pdfPathToOpen: string | null = null;
  loadingFull = false;
  form: FormGroup | undefined;
  TipoDocumentoId = -1;
  TipoDocumento: TipoDocumento[] = [];
  DetalleTipoDocumento: TipoDocumento[] = [];
  idTipoDocumento: number | undefined;
  IdDetalleTipoDocumento = -1;
  NOMBRE_TIPO_DOCUMENTO: string | undefined;
  qty = -1;
  Results = false;
  secondaryColor = '#567ba0';
  filas = 0;
  busqueda = false;
  infoUsers: any[] = [];
  gerenciasAreas: any[] = [];
  enableButton: boolean = false;

  headers = [
    {
      label: 'Codigo Documento',
      field: 'NOMBRE_DOCUMENTO',
      disableSort: false,
    },
    {
      label: 'Nombre Documento',
      field: 'CODIGO_DOCUMENTO',
      disableSort: false,
    },
    {
      label: 'Gerencia Documento',
      field: 'GERENCIA_DOCUMENTO',
      disableSort: false,
    },
    // { label: 'Palabra Claves', field: 'PALABRAS_CLAVES', disableSort: false },
    { label: 'Ver Doc', field: '', disableSort: false },
    { label: 'Editar', field: '', disableSort: false },
    { label: 'Registro de cambios', field: '', disableSort: false },
  ];
  formGroup: any;
  procedureData: TipoDocumento[] = [];
  AllTipoDocumento:
    | { value: any; label: any; NOMBRE_TIPO_DOCUMENTO: any; PARENT: any }[]
    | undefined;

  openPdfWithWatermark(pdfPath: string): void {
    // Navega a la vista del visor de PDF y pasa la URL del PDF como parámetro
    this.router.navigate(['/pdf-viewer'], { queryParams: { url: pdfPath } });
  }

  openPDF(rutaPDF: string) {
    window.open(rutaPDF, '_blank');
  }

  imprimirPDF() {
    const iframe = document.getElementById('pdfFrame') as HTMLIFrameElement;

    if (iframe) {
      // Obtén el contenido del iframe
      const iframeWindow = iframe.contentWindow;

      // Imprime el contenido del iframe
      iframeWindow?.print();
    }
  }

  getData(tags: Tag[]): void {
    let params = new HttpParams();
    for (let tag of tags) {
      params = params.append('tags', tag.name);
    }
  }
  search(event: Event): void {
    const searchTerm = (event.target as HTMLInputElement).value;
    this.table.search(searchTerm);
  }

  onEnterPress() {
    return false;
  }

  add(event: MdbChipAddEvent) {
    if (event.value.length > 0 && /\w{2,}/.test(event.value)) {
      this.tags.push({ name: event.value });
      event.input.clear();
    }
  }

  delete(tag: Tag) {
    const index = this.tags.indexOf(tag);

    if (index >= 0) {
      this.tags.splice(index, 1);
    }
  }

  onProcedureSelected(selectedValue: number) {
    const selectedCompany = this.TipoDocumento.find(
      (company) => company.value === selectedValue
    );
    if (selectedCompany) {
      this.TipoDocumentoId = selectedCompany.value;
    }
  }

  async ngOnInit() {
    try {
      this.loadingFull = true;

      forkJoin({
        documentType: this.getDocumentType(localStorage.getItem('IdCompany'), localStorage.getItem('appId')),
        users: this.getUsers(),
        gerenciasAreas: this.getGerenciasAreas(),
      }).subscribe({
        next: () => {
          this.loadingFull = false;
        },
        error: (err) => {
          console.error('Error al cargar datos:', err);
          this.loadingFull = false;
        },
      });
    } catch (error) {
      console.error('Error al cargar datos:', error);
      this.loadingFull = false;
    }
  }

  async getUsers(): Promise<void> {
    const body = new FormData();
    body.append('action', 'SELECT');
    body.append('table_name', 'USERS');

    return new Promise<void>((resolve, reject) => {
      this.crudService.crud(body, environment.GenericCrudOperation).subscribe(
        (data: any) => {
          if (data && data.status === 1 && data.data) {
            this.infoUsers = data.data.map((user: any) => {
              return {
                value: user.ID,
                label: user.SAMACCOUNTNAME,
                SAMACCOUNTNAME: user.SAMACCOUNTNAME,
              };
            });
            resolve(); // Resuelve la promesa una vez que se completa la operación
          } else {
            console.error('Error: No se pudo obtener la data de Users.');
            reject('Error al obtener la data de Users'); // Rechaza la promesa en caso de error
          }
        },
        (error) => {
          //this.loadingFull = false;
          console.error('Error: ', error);
          reject(error); // Rechaza la promesa en caso de error
        }
      );
    });
  }

  async getDocumentType(idCompany: any, idApp: any): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.httpClient
        .post<any[]>(environment.apiUrl + environment.GetDocumentType, {
          idTipoDocumento: 0,
          idCompany,
          idApp,
        })
        .subscribe(
          (data) => {
            this.TipoDocumento = data
              .filter((item: { PARENT: null }) => item.PARENT === null)
              .map((item: { ID: any; NOMBRE_TIPO_DOCUMENTO: any }) => ({
                value: item.ID,
                label: item.NOMBRE_TIPO_DOCUMENTO,
                NOMBRE_TIPO_DOCUMENTO: item.NOMBRE_TIPO_DOCUMENTO,
              }));
            this.AllTipoDocumento = data.map(
              (item: { ID: any; NOMBRE_TIPO_DOCUMENTO: any; PARENT: any }) => ({
                value: item.ID,
                label: item.NOMBRE_TIPO_DOCUMENTO,
                NOMBRE_TIPO_DOCUMENTO: item.NOMBRE_TIPO_DOCUMENTO,
                PARENT: item.PARENT,
              })
            );
            this.qty = this.TipoDocumento.length;
            resolve(); // Resuelve la promesa una vez que se completa la operación
          },
          (error) => {
            //this.loadingFull = false;
            console.error('Error: ', error);
            if (error.status == 401) {
              localStorage.clear();
              location.href = '/login';
            }
            reject(error); // Rechaza la promesa en caso de error
          }
        );
    });
  }

  async getGerenciasAreas(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.httpClient
        .post<any[]>(environment.apiUrl + environment.getGerenciasAreas, {
          idCompany: 1,
        })
        .subscribe(
          (data) => {
            this.gerenciasAreas = data.map(
              (item: {
                ID_GERENCIA: any;
                NOMBRE_GERENCIA: string;
                ID_AREA: any;
                NOMBRE_AREA: string;
              }) => ({
                value: item.ID_GERENCIA,
                label: item.NOMBRE_GERENCIA,
                ID_AREA: item.ID_AREA,
                NOMBRE_AREA: item.NOMBRE_AREA,
              })
            );

            //this.qty = this.TipoDocumento.length;
            resolve(); // Resuelve la promesa una vez que se completa la operación
          },
          (error) => {
            //this.loadingFull = false;
            console.error('Error: ', error);
            reject(error); // Rechaza la promesa en caso de error
          }
        );
    });
  }

  onChangeTipoDocumentoSelected(selectedValue: number) {
    this.IdDetalleTipoDocumento = selectedValue;
    this.enableButton = true;
  }

  onTipoDocumentoSelected(selectedValue: number) {
    this.idTipoDocumento = selectedValue;
    // se usa el operador coalescente nulo para proporcionar un valor predeterminado si por alguna razon AllTipoDocumento no está definido
    const allTipoDocumento = this.AllTipoDocumento ?? [];

    if (selectedValue !== null && selectedValue !== undefined) {
      // se filtra la data local basado en el selectedValue
      this.DetalleTipoDocumento = allTipoDocumento
        .filter((item) => item.PARENT === selectedValue)
        .map((item) => ({
          value: item.value,
          label: item.label,
          NOMBRE_TIPO_DOCUMENTO: item.NOMBRE_TIPO_DOCUMENTO,
        }));

      this.DetalleTipoDocumento.unshift({
        value: -1,
        label: 'TODOS',
        NOMBRE_TIPO_DOCUMENTO: '',
      });
    } else {
      this.DetalleTipoDocumento = [];
    }
  }

  isExternalLink(url: string): SafeResourceUrl | string {
    if (url.startsWith('http://') || url.startsWith('https://')) {
      return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    } else {
      return 'assets/pdfs/' + url;
    }
  }

  loadData() {
    const queryParams = {
      tags: this.tags,
      tipoDocumentoId:
        this.idTipoDocumento !== undefined ? Number(this.idTipoDocumento) : 0,
      detalleTipoDocumentoValue: this.IdDetalleTipoDocumento,
      idCompany: localStorage.getItem('IdCompany'),
      idApp: localStorage.getItem('appId'),
    };

    this.loadingFull = true;
    this.Results = true;
    this.qty = -1;

    this.filas = 0;
    this.busqueda = true;

    this.dataDocumentService
      .getData(environment.apiUrl + environment.documentSearch, queryParams)
      .pipe(take(1))
      .subscribe((data: any[]) => {
        // Procesa los datos y actualiza la dataSource
        this.filas = data.length;
        if (data && data.length > 0) {
          this.dataSource = data.map((doc) => ({
            ID: doc.ID,
            NOMBRE_DOCUMENTO: doc.NOMBRE_DOCUMENTO,
            CODIGO_DOCUMENTO: doc.CODIGO_DOCUMENTO,
            GERENCIA_DOCUMENTO: doc.NOMBRE_GERENCIA,
            PALABRAS_CLAVES: doc.PALABRAS_CLAVES,
            URLDOC: doc.URLDOC,
          }));

          this.Results = false;
          this.qty = data.length;
          this.loadingFull = false;
        } else {
          this.Results = false;
          this.qty = 0;
          this.loadingFull = false;
        }
      });

    return false;
  }

  openModalPDF(data: { URLDOC: string }) {
    const url = this.isExternalLink(data.URLDOC)
      ? data.URLDOC
      : 'assets/pdfs/' + data.URLDOC;
    window.open(url, '_blank');
  }

  async openModalInsertType(
    mode: 'add' | 'edit',
    insertType: number,
    tipoDoc: any,
    detalleTipoDoc: any,
    infoUsers: any,
    AllTipoDocumento: any,
    gerenciasAreas: any,
    idDocumento: number
  ): Promise<void> {
    this.modalRefDocuments = this.modalService.open(
      ModalDocumentosSgiComponent,
      {
        modalClass: insertType == 3 ? 'modal-xl' : '',
        data: {
          modalTitle:
            mode === 'edit'
              ? 'Editar Tipo de Documento'
              : 'Nuevo Tipo de Documento',
          insertType: insertType,
          TipoDocumento: tipoDoc,
          DetalleTipoDocumento: detalleTipoDoc,
          InfoUsers: infoUsers,
          AllTipoDocumento: AllTipoDocumento,
          GerenciasAreas: gerenciasAreas,
          idDocumentoForEdit: idDocumento,
          edit: mode === 'edit' ? 1 : 0,
        },
        ignoreBackdropClick: true,
      }
    );
    this.modalRefDocuments.onClose.subscribe((modalData: Company) => {
      if (!modalData) {
        return;
      }
      if (mode === 'add') {
        this.dataSource = [...this.dataSource, { ...modalData }];
      } else if (mode === 'edit') {
        /*const index = this.dataSource.indexOf();
        this.dataSource[index] = modalData;
        this.dataSource = [...this.dataSource];*/
      }
    });
    this.modalRefDocuments.component.OnGuardarClicked.subscribe(async () => {
      //this.ngOnInit();
      this.loadData();
      this.loadingFull = true;

      forkJoin({
        documentType: this.getDocumentType(localStorage.getItem('IdCompany'), localStorage.getItem('appId')),
        users: this.getUsers(),
        gerenciasAreas: this.getGerenciasAreas(),
      }).subscribe({
        next: () => {
          this.loadingFull = false;
        },
        error: (err) => {
          console.error('Error al cargar datos:', err);
          this.loadingFull = false;
        },
      });
    });
  }

  async openModalRegisterChange(
    id_document: number
  ): Promise<void> {
    console.log("id_documento: ", id_document);
    this.modalRefDocumentsDetail = this.modalService.open(
      ModalDocumentosDetailsComponent,
      {
        modalClass: 'modal-xl',
        data: {
          modalTitle: 'Registro de cambios y versionamiento',
          id_document,
        },
        ignoreBackdropClick: true,
      }
    );
  }
}
